import * as React from "react"
import { cn } from "@/lib/utils"

function Badge({ className, variant = "default", ...props }: React.ComponentProps<"div"> & {
  variant?: "default" | "secondary" | "destructive" | "outline"
}) {
  return (
    <div
      className={cn(
        "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
        {
          "border-transparent bg-corporate-blue-600 text-white hover:bg-corporate-blue-700": variant === "default",
          "border-transparent bg-corporate-gray-100 text-corporate-gray-900 hover:bg-corporate-gray-200": variant === "secondary",
          "border-transparent bg-red-500 text-white hover:bg-red-600": variant === "destructive",
          "border-corporate-gray-300 text-corporate-gray-900": variant === "outline",
        },
        className
      )}
      {...props}
    />
  )
}

export { Badge }
